/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017 - 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./SynchronizeDataModel'
], function(SynchronizeDataModel) {

	class SynchronizeService {
		/**
		 * The Synchronize Data service extension which manages access to the Synchronize Data API
		 * initialized with its model (as defined in the boardModelExtension).
		 */
		constructor (options = {}) {
			this.dashboardApi = options.dashboardApi;
		}

		/**
		 * Get public api of synchronizeData object
		 */
		getSynchronizeData () {
			if (!this.synchronizeData){
				var boardModel = this.dashboardApi.getFeature('internal').getBoardModel();
				this.synchronizeData = new SynchronizeDataModel([], {
					boardModel: boardModel,
					dashboardApi: this.dashboardApi
				});
			}
			return this.synchronizeData;
		}
	}

	return SynchronizeService;

});
